import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PayoutMethodsService } from '@app/modules/direct/services/payout-methods.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-payout-methods-get-kyc-link',
  template: `
    <div *ngIf="!error" class="flex flex-col items-center justify-center h-full space-y-4">
      <mat-spinner [diameter]="32"></mat-spinner>
      <div class="text__small">Checking...</div>
    </div>
    <div *ngIf="error" class="flex flex-col items-center justify-center h-full space-y-4">
      <mat-icon>error</mat-icon>
      <div class="text__small">Unable to generate verification link</div>
    </div>
  `,
})
export class DirectPayoutMethodsGetKYCLinkComponent implements OnInit {
  error = false;

  constructor(
    private route: ActivatedRoute,
    private payoutMethodsService: PayoutMethodsService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.uuid) {
        this.payoutMethodsService.adyenGetVerifyLink(params.uuid).subscribe(
          (res) => {
            if (res.data?.url) {
              window.location.href = res.data.url;
            } else {
              this.onError();
            }
          },
          () => {
            this.onError();
          }
        );
      } else {
        this.onError();
      }
    });
  }

  onError() {
    this.error = true;
  }
}
